import { DateTime } from "luxon"

export const START_HOUR = 7
export const END_HOUR = 19

export const isAllowedTime = () => {
  const now = DateTime.now()
  return now.hour >= START_HOUR && now.hour < END_HOUR
}
